import { ApplicationTypes, DeadboltHole, attachComponent, featureLabels } from 'metalworks-domain'

import { detailComponent, entityHeaderComponent, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { GenericDistancePropertyPage } from '../ui/property-pages/GenericDistancePropertyPage'
import { createInnerRadiusDimensionIndicatorComponent } from './common'

export const deadboltHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('DeadboltHole')
    .attach(() => {
      return {
        title: featureLabels[DeadboltHole.type],
        subtitle: 'Fixed diameter',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('DeadboltHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <GenericDistancePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('DeadboltHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  createInnerRadiusDimensionIndicatorComponent('DeadboltHole'),
]
